export default __webpack_public_path__ + "static/media/Album.eb0c93ee.svg";